import { createRouter } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import * as TanstackQuery from './integrations/tanstack-query/root-provider'

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { ErrorComponent } from './components/error-component'

const rqContext = TanstackQuery.getContext()

export const router = createRouter({
  hydrate: false as never,
  routeTree,
  context: { ...rqContext },
  defaultPreload: 'intent',
  defaultErrorComponent: ({ error, info, reset }) => (
    <ErrorComponent error={error} info={info} reset={reset} />
  ),
  Wrap: ({ children }: { children: ReactNode }) => (
    <TanstackQuery.Provider {...rqContext}>{children}</TanstackQuery.Provider>
  ),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
